import type { EFeatureFlag } from "@frontend-shared/constants";
import { FEATURE_FLAGS } from "@frontend-shared/constants";
import { resolveFeatureFlag } from "@frontend-shared/utils";

import { useAppConfig } from "@/api/app-config/useAppConfig";
import { featureFlagStore } from "@/lib/feature-flags";

// NOTE: NSAI-1249 — the one gate every web feature flag now goes through.
// Combines the deployment's /app-config answer with this browser's opt-in via
// the shared resolver, so web and mobile cannot drift on what "enabled" means:
// `remoteEnabled || (optedIn && the override is allowed)`.
//
// The opt-in is read on every render rather than held in state, matching what
// the hand-written hooks this replaces did — localStorage is edited from
// DevTools, which fires no event this app listens to, so a change lands on the
// next reload either way.
export const useFeatureFlag = (flag: EFeatureFlag): boolean => {
  const { data: appConfig } = useAppConfig();
  const definition = FEATURE_FLAGS[flag];

  return resolveFeatureFlag({
    definition,
    appConfig,
    isOptedInLocally: featureFlagStore.isOptedIn(definition),
  });
};
